// extracted by mini-css-extract-plugin
export default {"mCard":"OB-z","image":"PB-z","imageNoBackground":"QB-z","imageHasCategory":"RB-z","fullWidth":"SB-z"};